'use client';

import { Button } from '@askable/ui/core/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@askable/ui/core/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@askable/ui/core/tooltip';
import { HelpCircle, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { IntercomMenuItem, IntercomMenuItemProvider } from '@/components/IntercomMenuItem/IntercomMenuItem';
import { useIntercomSurvey } from '@/hooks/useIntercomSurvey/useIntercomSurvey';
import { useSegment } from '@/hooks/useSegment/useSegment';

export const HelpMenu = () => {
  const startSurvey = useIntercomSurvey();
  const { trackEvent } = useSegment();
  const { t } = useTranslation();

  return (
    <IntercomMenuItemProvider>
      <DropdownMenu>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="!hidden sm:!flex">
                <HelpCircle className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>{t('global.getHelp')}</TooltipContent>
        </Tooltip>

        <DropdownMenuContent align="end">
          <DropdownMenuItem
            onClick={() => {
              startSurvey();
              trackEvent('click_insight_help_menu_feedback');
            }}
          >
            <Heart className="h-4 w-4" />
            {t('global.giveFeedback')}
          </DropdownMenuItem>
          <IntercomMenuItem onClick={() => trackEvent('click_insight_help_menu_support')} />
        </DropdownMenuContent>
      </DropdownMenu>
    </IntercomMenuItemProvider>
  );
};
